import React from 'react';
import Icon from '../ui/Icon';

const statusConfig = {
  active: { label: 'Active', className: 'badge-emerald' },
  pending: { label: 'Pending', className: 'badge-amber' },
  inactive: { label: 'Inactive', className: 'badge-slate' }
};

export default function AgentCard({ agent, onEdit }) {
  const status = statusConfig[agent.status] || statusConfig.pending;
  
  return (
    <div className="card">
      <div className="p-6">
        <div className="flex items-start gap-4">
          <div style={{ position: 'relative' }}>
            <img 
              src={agent.photo_url || `https://ui-avatars.com/api/?name=${encodeURIComponent(agent.full_name)}&background=0f172a&color=d4a373&size=80`}
              alt={agent.full_name}
              style={{ width: '4rem', height: '4rem', borderRadius: '0.75rem', objectFit: 'cover' }}
            />
            <div style={{
              position: 'absolute',
              bottom: '-0.25rem',
              right: '-0.25rem',
              width: '1rem',
              height: '1rem',
              borderRadius: '50%',
              border: '2px solid white',
              background: agent.status === 'active' ? 'var(--emerald-500)' : 'var(--slate-300)'
            }} />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between">
              <div>
                <h3 className="font-semibold text-slate-900 text-lg">
                  {agent.full_name}
                </h3>
                <span className={`badge ${status.className}`} style={{ marginTop: '0.25rem' }}>
                  {status.label}
                </span>
              </div>
              <button className="btn btn-ghost btn-icon" onClick={() => onEdit?.(agent)}>
                <Icon name="edit" size={16} />
              </button>
            </div>
          </div>
        </div>
        
        <div className="mt-4" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          <div className="flex items-center gap-2 text-sm text-slate-600">
            <Icon name="award" size={16} style={{ color: 'var(--amber-500)' }} />
            <span>License: {agent.license_number}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-slate-600">
            <Icon name="mail" size={16} />
            <span className="truncate">{agent.email}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-slate-600">
            <Icon name="phone" size={16} />
            <span>{agent.phone}</span>
          </div>
        </div>
        
        {agent.specializations?.length > 0 && (
          <div className="mt-4 flex flex-wrap gap-1">
            {agent.specializations.map((spec, i) => (
              <span key={i} className="badge badge-slate" style={{ fontSize: '0.7rem' }}>
                {spec}
              </span>
            ))}
          </div>
        )}
        
        {agent.commission_rate && (
          <div className="mt-4" style={{ paddingTop: '1rem', borderTop: '1px solid var(--slate-100)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span className="text-sm text-slate-500">Commission Rate</span>
            <span className="font-semibold text-slate-900">{agent.commission_rate}%</span>
          </div>
        )}
      </div>
    </div>
  );
}